/**
 * Created by prog2 on 25/10/2018.
 */

import catala from './catala';
import castellano from './castellano';
import english from './english';
import français from './français';

const messages = {
    Català: catala,
    Castellano: castellano,
    English: english,
    Français: français,

}

export default messages;



// WEBPACK FOOTER //
// ./src/data/i18n/i18n.js